export default "/048cb1f2b29308e18768c65cfd51e426596a830c/20e765fe22790b7f1075e229233d4cab.svg";